<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <div class="home-logo">
                <a (click)="helperService.goToHomePage(navCtrl)">
                    <img src="assets/imgs/logo.png" width="32px" height="32px" alt="CALLIDUS Logo">
                </a>
            </div>
            <div>
                <ion-title>{{ 'UPLOAD_TEXT' | translate }}
                </ion-title>
            </div>
            <ion-spinner *ngIf="helperService.openRequests.length"></ion-spinner>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-menu-button autoHide="false">
                <ion-icon name="menu"></ion-icon>
            </ion-menu-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col>
                <ion-button (click)="navCtrl.pop()">{{ 'BACK' | translate }}</ion-button>
            </ion-col>
            <ion-col>
                <ion-button (click)="showTextComplexity()">
                    {{ "ANALYZE_TEXT" | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-label>{{ 'MY_TEXT' | translate }}</ion-label>
                <ion-textarea placeholder="{{ 'PASTE_TEXT_HERE' | translate }}" [(ngModel)]="currentText"
                              inputmode="text" style="border: 1px solid black; margin: auto; max-width: fit-content"
                              [autoGrow]="true">
                </ion-textarea>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
